import React, { useState, useEffect } from 'react';
import { usePushNotifications } from '../hooks/usePushNotifications';
import { Bell, X } from 'lucide-react';

const PushPrompt = () => {
  const [show, setShow] = useState(false);
  const { isSubscribed, isSupported, permission, subscribe } = usePushNotifications();

  useEffect(() => {
    if (!isSupported || isSubscribed || permission === 'denied') return;
    // Show prompt after a short delay, but only once per session
    const dismissed = sessionStorage.getItem('push_prompt_dismissed');
    if (dismissed) return;
    const timer = setTimeout(() => setShow(true), 3000);
    return () => clearTimeout(timer);
  }, [isSupported, isSubscribed, permission]);

  const handleEnable = async () => {
    await subscribe();
    setShow(false);
    sessionStorage.setItem('push_prompt_dismissed', '1');
  };

  const handleDismiss = () => {
    setShow(false);
    sessionStorage.setItem('push_prompt_dismissed', '1');
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[200] max-w-sm animate-in slide-in-from-bottom-5 duration-300" data-testid="push-prompt">
      <div className="bg-white rounded-xl shadow-2xl border border-gray-200 p-4">
        <button onClick={handleDismiss} className="absolute top-2 right-2 p-1 hover:bg-gray-100 rounded-full">
          <X className="w-4 h-4 text-gray-400" />
        </button>
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
            <Bell className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <h4 className="text-sm font-semibold text-gray-900">Enable Notifications</h4>
            <p className="text-xs text-gray-500 mt-1">Get instant alerts for job updates, approvals, and more — even when the app is in the background.</p>
            <div className="flex gap-2 mt-3">
              <button
                onClick={handleEnable}
                className="px-3 py-1.5 text-xs font-medium bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                data-testid="push-prompt-enable"
              >
                Enable
              </button>
              <button
                onClick={handleDismiss}
                className="px-3 py-1.5 text-xs font-medium text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                data-testid="push-prompt-dismiss"
              >
                Not now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PushPrompt;
